import React from "react";
import { useTranslation } from "react-i18next";
import { TableTabs } from "@/components/DataTable/TableTabs";
import { FeedPostTab } from "./FeedPostTab";
import { useLocation } from "react-router-dom";
import {
  FeedPostSortableFieldEnum,
  FeedPostStatusEnum,
  SortDirectionEnum,
} from "@/__generated__/graphql";

export const FeedPostsTable = () => {
  const { t } = useTranslation();
  const { hash } = useLocation();

  return (
    <TableTabs
      activeTab={hash === "#active" ? 1 : 0}
      className="rounded-lg border shadow-sm"
      tabs={[
        {
          label: t("feedPost.table.tabs.scheduled"),
          children: (
            <FeedPostTab
              statuses={[FeedPostStatusEnum.Scheduled]}
              title={t("feedPost.table.scheduled.title")}
              subtitle={t("feedPost.table.scheduled.subtitle")}
              emptyState={t("feedPost.table.scheduled.emptyState")}
              ordering={[
                {
                  field: FeedPostSortableFieldEnum.PublishDate,
                  direction: SortDirectionEnum.Asc,
                },
              ]}
            />
          ),
        },
        {
          label: t("feedPost.table.tabs.active"),
          children: (
            <FeedPostTab
              statuses={[FeedPostStatusEnum.Active]}
              title={t("feedPost.table.active.title")}
              subtitle={t("feedPost.table.active.subtitle")}
              emptyState={t("feedPost.table.active.emptyState")}
              ordering={[
                {
                  field: FeedPostSortableFieldEnum.PublishDate,
                  direction: SortDirectionEnum.Desc,
                },
              ]}
            />
          ),
        },
      ]}
    />
  );
};
